import {createSelector} from "@reduxjs/toolkit";
import {isEmpty} from "es-toolkit/compat";
import {
  resultsDataSelector,
  resultsHealthCategoriesSelector,
  resultsHealthCategorySelectedSelector,
  resultsHistorySelector,
  resultsMetadataSelector,
  resultsStatusSelector,
  resultsSupplementsSelector,
} from "./resultsSlice";

//   resultsStatusSelector,

export const selectResultsData = createSelector([resultsDataSelector], data => {
  return !isEmpty(data) ? data : [];
});

export const selectResultsMetadata = createSelector([resultsMetadataSelector], metadata => {
  return !isEmpty(metadata) ? metadata : {};
});

export const selectResultsHistory = createSelector([resultsHistorySelector], history => {
  return !isEmpty(history) ? history : [];
});

export const selectResultsHealthCategories = createSelector([resultsHealthCategoriesSelector], categories => {
  return !isEmpty(categories) ? categories : [];
});

export const selectResultsSupplements = createSelector([resultsSupplementsSelector], supplements => {
  return !isEmpty(supplements) ? supplements : [];
});

export const selectResultsStatus = createSelector([state => state.results], state => ({
  hasFailed: state.hasFailed,
  isFetching: state.isFetching,
  errorMsg: state.errorMsg,
}));

export const selectResultsHealthCategorySelected = createSelector(
  [resultsHealthCategorySelectedSelector],
  healthCategoryId => healthCategoryId ?? "",
);
